t = require('app/scripts/views/internal/teacup-with-helpers')('select_card')

module.exports = t.renderable ({ name, id, closed, boardName })->
  t.li '.item', ->
    t.a '.name.js-select-card', { href: '#', title: name, 'data-id': id }, ->
      t.span '.item-name', ->
        t.text name
        if closed
          t.text ' '
          t.span '.quiet', ->
            t.format 'archived'
      if boardName
        t.span '.sub-name', ->
          t.format 'in-boardname', { boardName }
